import { PediatricTraumaScoreConstants } from './pediatricTraumaScore.constants'
import { IPediatricTraumaScoreState, IPediatricTraumaScoreAction } from './pediatricTraumaScore.types'

export const initialPediatricTraumaScoreState: IPediatricTraumaScoreState = {
  ptsTotal: null,
  ptsSize: null,
  ptsAir: null,
  ptsBp: null,
  ptsCns: null,
  ptsSkel: null,
  ptsWound: null,
}

export function pediatricTraumaScoreReducer(
  state: IPediatricTraumaScoreState = initialPediatricTraumaScoreState,
  action: IPediatricTraumaScoreAction
): IPediatricTraumaScoreState {
  switch (action.type) {
    case PediatricTraumaScoreConstants.SET_TOTAL_SCORE:
      return { ...state, ptsTotal: action.ptsTotal }
    case PediatricTraumaScoreConstants.SET_SIZE:
      return { ...state, ptsSize: action.ptsSize }
    case PediatricTraumaScoreConstants.SET_AIRWAY:
      return { ...state, ptsAir: action.ptsAir }
    case PediatricTraumaScoreConstants.SET_SYSBP:
      return { ...state, ptsBp: action.ptsBp }
    case PediatricTraumaScoreConstants.SET_CNS:
      return { ...state, ptsCns: action.ptsCns }
    case PediatricTraumaScoreConstants.SET_SKELETAL_INJURY:
      return { ...state, ptsSkel: action.ptsSkel }
    case PediatricTraumaScoreConstants.SET_OPEN_WOUNDS:
      return { ...state, ptsWound: action.ptsWound }
    case PediatricTraumaScoreConstants.SET_PTS_DATA:
      return { ...state, ...action.ptsData }
    case PediatricTraumaScoreConstants.RESET_PTS_DATA:
      return { ...initialPediatricTraumaScoreState }

    default:
      return state
  }
}
